import { Bitmap, Color, MovieClip, Sprite, TextFormat } from "../runtime";
import { G_menuBoxSmall, G_menuBoxSmallHighlight, blackBlock2 } from "./assets";
import {
  FONT_BODY,
  FONT_DISPLAY,
  TEXT_COLOURS,
  createTextField,
} from "./textStyle";

/**
 * Full-screen "this will erase your progress" prompt with a YES/NO pair of
 * menu boxes. The selected box is highlighted, and confirming strobes it for
 * 26 frames before reporting the choice back to Game.
 */
export class ConfirmBox extends MovieClip {
  boxSelected = true;
  private readonly highlight0: Bitmap;
  private readonly highlight1: Bitmap;
  private sidePressed = false;
  private spacePressed = false;
  private highlightCounter = 0;
  private actionCounter = 0;
  private flashing = false;
  private readonly options: MovieClip[] = [];

  constructor() {
    super();
    const format = new TextFormat();
    const formatSpeaker = new TextFormat();
    const bgBlack = new Sprite();
    bgBlack.graphics.beginBitmapFill(new blackBlock2());
    bgBlack.graphics.drawRect(0, 0, 720, 480);
    bgBlack.graphics.endFill();
    this.addChild(bgBlack);
    format.align = "center";
    format.font = FONT_BODY;
    format.color = TEXT_COLOURS.white;
    format.size = 20;
    formatSpeaker.align = "center";
    formatSpeaker.bold = true;
    formatSpeaker.font = FONT_DISPLAY;
    formatSpeaker.color = TEXT_COLOURS.aqua;
    formatSpeaker.size = 32;
    createTextField(this, format, {
      width: 720,
      height: 100,
      y: 140,
      text: "This will erase your progress!\nAre you sure you want to continue?",
    });
    this.highlight0 = this.addOption(360 - 85, "YES", formatSpeaker);
    this.highlight1 = this.addOption(360 + 85, "NO", formatSpeaker);
    this.updateSelection();
  }

  /** 0 = idle, 2 = selection moved, 3 = confirmed, 1 = strobe finished. */
  update(input: readonly boolean[]): number {
    let returnValue = 0;
    if (!this.spacePressed) {
      if (input[2] || input[3]) {
        if (!this.sidePressed) {
          this.sidePressed = true;
          this.boxSelected = !this.boxSelected;
          this.updateSelection();
          returnValue = 2;
        }
      } else if (this.sidePressed) {
        this.sidePressed = false;
      }
      if (input[4]) {
        this.spacePressed = true;
        this.flashing = true;
        returnValue = 3;
      }
    } else {
      if (this.flashing) {
        this.updateGlow();
      }
      ++this.actionCounter;
      if (this.actionCounter === 26) {
        this.flashing = false;
        const cOff = new Color();
        cOff.setTint(16777215, 0);
        this.highlight0.transform.colorTransform = cOff;
        this.highlight1.transform.colorTransform = cOff;
        returnValue = 1;
      }
    }
    return returnValue;
  }
  /** Selects a YES/NO box under a stage-space pointer. */
  pointerDown(stageX: number, stageY: number): boolean {
    if (this.spacePressed) return false;
    const option = this.options.findIndex((holder) =>
      holder.hitTestPoint(stageX, stageY),
    );
    if (option < 0) return false;
    this.boxSelected = option === 1;
    this.updateSelection();
    return true;
  }

  /** Builds one option box and returns its (initially hidden) highlight layer. */
  private addOption(x: number, label: string, format: TextFormat): Bitmap {
    const holder = new MovieClip();
    holder.x = x;
    holder.y = 270;
    this.addChild(holder);
    this.options.push(holder);
    const boxSpr = new Bitmap(new G_menuBoxSmall());
    boxSpr.x = boxSpr.width * -0.5;
    boxSpr.y = boxSpr.height * -0.5;
    holder.addChild(boxSpr);
    const highlight = new Bitmap(new G_menuBoxSmallHighlight());
    highlight.x = highlight.width * -0.5;
    highlight.y = highlight.height * -0.5;
    holder.addChild(highlight);
    highlight.visible = false;
    createTextField(holder, format, {
      width: 64,
      height: 64,
      centerX: true,
      y: -20,
      text: label,
    });
    return highlight;
  }

  // boxSelected true means NO is lit, which is why the flags read inverted
  private updateSelection(): void {
    this.highlight0.visible = !this.boxSelected;
    this.highlight1.visible = this.boxSelected;
  }

  private updateGlow(): void {
    const c = new Color();
    let cAmount = 1;
    ++this.highlightCounter;
    if (this.highlightCounter >= 2) {
      cAmount = 0;
      if (this.highlightCounter === 3) {
        this.highlightCounter = 0;
      }
    }
    c.setTint(16777215, cAmount);
    if (this.boxSelected) {
      this.highlight1.transform.colorTransform = c;
    } else {
      this.highlight0.transform.colorTransform = c;
    }
  }
}
